import request from '@/utils/request';

export async function qryPortalList() {
  return request('/portals');
}

export async function qryDirMenus(portalId) {
  return request(`/portals/${portalId}/dirmenus`);
}

export async function delPortal(portalId) {
  return request(`/portals/${portalId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
}

export async function addPortal(params) {
  return request('/portals', {
    method: 'POST',
    body: {
      ...params,
    },
  });
}

export async function updatePortal(params) {
  return request('/portals', {
    method: 'PUT',
    body: {
      ...params,
    },
  });
}

export async function delDirMenu(portalId, partyId, seq) {
  return request(`/portals/${portalId}/dirmenus/${partyId}/${seq}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
}

export async function updateDirMenu(portalId, portalDirMenuList) {
  return request(`/portals/${portalId}/dirmenus/seq`, {
    method: 'PUT',
    body: portalDirMenuList,
  });
}

export async function qryAllMenus() {
  return request('/menus');
}

export async function addDirMenuToPortal(portalId, portalDirMenuList) {
  return request(`/portals/${portalId}/dirmenus`, {
    method: 'POST',
    body: portalDirMenuList,
  });
}

export async function qryDirMenuList(dirId) {
  return request(`/dirs/${dirId}/dirmenus`);
}
